import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isRecurringMaster } from 'owa-calendar-event-capabilities';

/**
 * If forSeriesMaster is false, get the key used to cache the event OR
 * If forSeriesMaster is true, get the event key used to cache the series master of the event instance
 *
 * TODO VSO 82211: `cal-cache-update` flight clean up, remove forSeriesMaster param
 * in favor of using getSeriesMasterEventKeyFromInstance directly
 * @param event event
 * @param forSeriesMaster boolean
 */
export default function getEventKey(
    event: CalendarEvent | Partial<CalendarEvent>,
    forSeriesMaster: boolean = false
): string {
    if (isFeatureEnabled('cal-cache-update')) {
        // TODO VSO 83668: graduate cal-cache-update flight. remove `!isRecurringMaster(event.CalendarItemType)` when `cal-cache-update` is graduated,
        // This check is needed in the mean time to support both versions of the cache, so that when getEventKey(seriesMasterItem, true) is called,
        // we return the itemId of the event.
        return forSeriesMaster && !isRecurringMaster(event.CalendarItemType)
            ? getSeriesMasterEventKeyFromInstance(event)
            : event?.ItemId?.Id;
    } else {
        return forSeriesMaster || isRecurringMaster(event.CalendarItemType)
            ? event.InstanceKey
            : event.ItemId.Id;
    }
}

/**
 * Get the event key used to cache the series master of the event instance
 * @param instanceEvent instance of a series
 */
export function getSeriesMasterEventKeyFromInstance(
    instanceEvent: CalendarEvent | Partial<CalendarEvent>
): string {
    return instanceEvent.SeriesMasterItemId?.Id;
}
